import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { FormatterService } from "../../../../services/formatter.service";

@Component({
  selector: "page-reservation-list",
  templateUrl: "./index.component.html",
})
export class PageReservationListComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any = {};
  public searchParams: any = {};
  public pagination: any = {};

  constructor(
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public authService: AuthService,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public formatterService: FormatterService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    this.searchParams = {
      offset: 0,
      limit: this.commonService.appConfig.reservation.searchPageLimits,
    };

    /* PAGINATION */
    this.pagination = {
      offset: 0,
      limit: this.searchParams.limit,
      totalReservations: 0,
      currentPage: 1,
      totalPages: 0,
      pageSegmentLimit:
        this.commonService.appConfig.reservation.paginationPageSegmentLimits,
      currentSegment: 1,
      totalSegments: 0,
      pageItems: [],
      hasPrev: false,
      hasNext: false,
    };
  }

  async ngOnInit() {
    /* CHECK IF NOT LOGGED IN */
    if (!this.authService.isLoggedIn()) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHomeNoParam
      );
    }

    /* SET PAGE TITLE */
    this.commonService.setTitle(`予約リスト | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* CHECK PAGE FROM URL */
    let page = parseInt(this.activatedRoute.snapshot.paramMap.get("page"));
    if (page > 1) {
      /* SET CURRENT PAGE & SEGMENT */
      this.pagination.currentPage = page;

      this.pagination.currentSegment =
        (this.pagination.currentPage * this.pagination.limit) /
        (this.pagination.limit * this.pagination.pageSegmentLimit);
      this.pagination.currentSegment = Number.isInteger(
        this.pagination.currentSegment
      )
        ? this.pagination.currentSegment
        : parseInt(this.pagination.currentSegment) + 1;

      this.doPagination();
    }

    /* GET RESERVATION DATA */
    this.reservationData = await this.reservationService.getReservationList(
      this.searchParams
    );
    this.pagination.totalReservations = this.reservationData.totalReservations;

    /* CALCULATE TOTAL PAGES & TOTAL SEGMENT */
    /* TOTAL PAGES */
    let totalRemainder =
      this.pagination.totalReservations % this.pagination.limit;
    let total = this.pagination.totalReservations / this.pagination.limit;
    this.pagination.totalPages =
      totalRemainder === 0 ? total : parseInt(total.toString()) + 1;

    /* CHECK INVALID PAGE */
    if (
      this.pagination.totalReservations > 0 &&
      this.pagination.currentPage > this.pagination.totalPages
    ) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationList
      );
    }
    /* END */

    /* TOTAL SEGMENTS */
    totalRemainder =
      this.pagination.totalPages % this.pagination.pageSegmentLimit;
    total = this.pagination.totalPages / this.pagination.pageSegmentLimit;
    this.pagination.totalSegments =
      totalRemainder === 0 ? total : parseInt(total.toString()) + 1;
    /* END */

    this.doPagination();

    /* CLEAR TEMP CACHES */
    this.commonService.removeData("searchReservationDataDetail");
    this.commonService.removeData("searchReservationDataEmail");

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  doPagination() {
    /* PREV & NEXT */
    this.pagination.hasPrev = this.pagination.currentSegment > 1 ? true : false;
    this.pagination.hasNext =
      this.pagination.currentSegment < this.pagination.totalSegments
        ? true
        : false;

    /* SET PAGE RANGE */
    this.paginationSetPageRange();

    /* SET SEARCH DATA */
    this.searchParams.offset =
      (this.pagination.currentPage - 1) * this.pagination.limit;
    this.pagination.offset = this.searchParams.offset;

    /* SET URL */
    if (this.pagination.currentPage > 1) {
      this.location.replaceState(
        `${this.commonService.routePaths.pageReservationListNoParam}/${this.pagination.currentPage}`
      );
    } else {
      this.location.replaceState(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }
  }

  paginationChangePageSegment(type: string = "prev") {
    if (type == "prev") {
      this.pagination.currentSegment--;
    } else if (type == "next") {
      this.pagination.currentSegment++;
    }

    /* SET PAGE RANGE */
    this.paginationSetPageRange();

    this.doPagination();
  }

  paginationSetPageRange() {
    this.pagination.pageItems = [];
    let pageStart =
      this.pagination.currentSegment * this.pagination.pageSegmentLimit -
      this.pagination.pageSegmentLimit +
      1;
    let pageEnd = pageStart + this.pagination.pageSegmentLimit;
    pageEnd =
      pageEnd < this.pagination.totalPages
        ? pageEnd
        : this.pagination.totalPages + 1;

    for (let i = pageStart; i < pageEnd; i++) {
      this.pagination.pageItems.push(i);
    }
  }

  async getList(page: number = 1) {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET NEW PAGINATION DATA */
    this.pagination.currentPage = page;
    this.doPagination();

    /* GET RESERVATION DATA */
    this.reservationData = await this.reservationService.getReservationList(
      this.searchParams
    );

    /* SCROLL TO TOP */
    this.$("html, body").animate({ scrollTop: 0 }, 250);
    /* END */

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  inlineJS() {
    let self = this;

    //fixフッターがある場合
    self.$(window).scroll(function () {
      if (self.$(".footer-fix").length) {
        let footerHight = self.$(".footer-fix").outerHeight();
        self.$(".main-container").css("padding-bottom", footerHight);
      }
    });
    /* END */
  }
}
